// extracted by mini-css-extract-plugin
export default {"link":"link__EMWMVXxK","button":"button__qXMbN2f1","icon":"icon__ebmf3Jyx"};